import { useRef } from 'react'

import Lottie, { LottieRefCurrentProps } from 'lottie-react'

import { MissionBackgroundRotation2Image, MissionRewardIcon } from '@local/assets/images'

import Image, { PupKeywordEmoji } from '@web/components/Image'
import { useRegistToSequentialList } from '@web/libs/sequential'
import Place_ReviewCoindrop from '@web/pages/mission/modal/lottie/Place_ReviewCoindrop.json'

import styles from '../MissionRewardPopup.module.scss'

interface Props {
  title: string
  amount: number
  animationOrder: number
}

const RegionReviewRewardPopup = ({ title, amount, animationOrder }: Props) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null)

  useRegistToSequentialList({
    order: animationOrder * 100,
    onExecute: () => {
      lottieRef.current?.setSpeed(2)
      lottieRef.current?.play()
    },
    type: 'afterPrev',
    delaySeconds: 0,
    durationSeconds: 1.5,
    id: `reward-popup-${animationOrder}`,
  })

  return (
    <>
      <div className={styles.animation_wrapper}>
        <Image className={styles.img_bg} src={MissionBackgroundRotation2Image} width={680} height={680} alt="" />
      </div>
      <div className={styles.content}>
        <div className={styles.mission}>미션 결과</div>
        <div className={styles.tit_area}>{title}!</div>
        <div className={styles.lottie_area}>
          <Lottie
            lottieRef={lottieRef}
            className={styles.lottie_coin_drop}
            autoplay={false}
            loop={false}
            animationData={Place_ReviewCoindrop}
          />
        </div>
        <div className={styles.txt_area}>
          <Image className={styles.icon} src={MissionRewardIcon} width={29} height={29} alt="" />
          <em>포인트 {amount.toLocaleString()}원</em> 당첨!
        </div>
        <div className={styles.description_area}>
          방방곡곡 많은 곳을 다니셨군요!
          <br />
          당첨을 축하합니다
          <Image className={styles.icon} src={PupKeywordEmoji.PARTY_POPPER} width={18} height={18} alt="" />
        </div>
      </div>
    </>
  )
}

export default RegionReviewRewardPopup
